import { Map } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { CREATE_NON_TASK, GET_NON_TASKS, UPDATE_NON_TASK, DELETE_NON_TASK } from './actions'

export const INITIAL_STATE = new Map()

export const nonTaskSchema = new schema.Entity('nonTask', {}, { idAttribute: '_id' })

export const nonTask = createReducer(INITIAL_STATE, {
  [GET_NON_TASKS.FULFILLED]: (state, { payload }) =>
    new Map(normalize(payload, [nonTaskSchema]).entities.nonTask),

  [DELETE_NON_TASK.FULFILLED]: (state, { payload }) => state.delete(payload),

  [CREATE_NON_TASK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [nonTaskSchema]).entities.nonTask),

  [UPDATE_NON_TASK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [nonTaskSchema]).entities.nonTask),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/non-task/reducers.js